//Constants
import * as ACTIONS from './actionTypes';

//Types
import { ActionGetUrlUpgradeAPISuccess } from './actions';
export interface UrlUpgradeState {
    url?: string
}

const defaultState: UrlUpgradeState = {
    url: undefined
};


type UrlUpgradeAction = ActionGetUrlUpgradeAPISuccess;

function urlUpgradeReducer(state: UrlUpgradeState = defaultState, action: UrlUpgradeAction): UrlUpgradeState {
    switch (action.type) {
        case ACTIONS.GET_URLUPGRADE_API_SUCCESS:
            {
                const { url } = action as ActionGetUrlUpgradeAPISuccess;
                return {
                    ...state,
                    url: url
                }
            }
    }
    return {
        ...state
    }
}

export default urlUpgradeReducer;